/* keep in sync with ./sizes.css */

export const SIDEBAR_WIDTH = 300;
export const LINE_NUMBER_WIDTH = 35;
export const CONTENT_WRAPPER_WIDTH = 720;
export const CONTENT_WIDTH = CONTENT_WRAPPER_WIDTH + LINE_NUMBER_WIDTH;
export const SUGGESTION_LIST_HEIGHT = 380;
